import { render, staticRenderFns } from "./CouponPreview.vue?vue&type=template&id=517e8104&"
import script from "./CouponPreview.vue?vue&type=script&lang=js&"
export * from "./CouponPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports